<script>
	import { Doughnut } from 'vue-chartjs';

	export default {
		extends: Doughnut,
		props: ['data'],
		data() {
			return {
				colorDeptos: {
					RB: '#f44336',
					ITA: '#9c27b0',
					TAN: '#673ab7',
					CAS: '#e91e63',
					NIT: '#00bcd4',
					SOL: '#009688',
					CAC: '#4caf50',
					MAG: '#8bc34a',
					SG: '#2196f3',
					MAC: '#ffeb3b',
					MAR: '#ff9800',
					BAC: '#ff5722',
					ARA: '#795548',
					SAQ: '#9e9e9e',
					CAB: '#607d8b',
					CAM: '#00e676',
					RJ: '#c6ff00',
					SOL: '#880e4f',
					SST: '#37474f',
				},
			};
		},
		mounted() {
			this.renderChart(
				{
					labels: this.data.map((item) => item.regiao),

					datasets: [
						{
							data: this.data.map((item) => item.qnt),
							backgroundColor: this.data.map(
								(item) => this.colorDeptos[item.regiao]
							),
						},
					],
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'right',
					},
				}
			);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/contratos-por-regiao.vue